import request from '@/router/axios'

const baseUrl = '/api/produce/emergency-task'

export const getList = (data) => {
  return request({
    url: `${baseUrl}/select/page`,
    method: 'post',
    data
  })
}

export const insert = (data) => {
  return request({
    url: `${baseUrl}/insert`,
    method: 'post',
    data
  })
}

export const update = (data) => {
  return request({
    url: `${baseUrl}/update`,
    method: 'post',
    data
  })
}

export const getDetail = (id) => {
  return request({
    url: `${baseUrl}/select/id`,
    method: 'get',
    params: { id }
  })
}

export const remove = (id) => {
  return request({
    url: `${baseUrl}/delete/id`,
    method: 'get',
    params: { id }
  })
}
